module.exports = __webpack_public_path__ + "static/media/map_3-3.8fccd7e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/map_3-3.svg
// module id = 764
// module chunks = 0